import { IUpsellGroupListResponse, UpsellGroupList } from "types/upsellGroup";
import { IArticleResponse, Article } from "types/article";
import { IMenuResponse, IMenuListingResponse, Menu } from "types/menu";
import { AbortAction, ApiService } from "./Api.service";

// API layer
export class MenuAPIService {
	static async getMenu(menuId: string, isFastTrack: boolean): Promise<IMenuResponse> {
		return ApiService.fetch(
			`menus/${menuId}${isFastTrack ? "?isFastTrack=true" : ""}`,
			undefined,
			undefined,
			"v2",
		);
	}

	static async getMenus(placeId: string, deliveryOptionType?: string): Promise<IMenuListingResponse> {
		const query = deliveryOptionType ? `?deliveryOptionType=${deliveryOptionType}` : "";
		return ApiService.fetch(`places/${placeId}/menus${query}`);
	}

	static async getMenuArticle(
		menuId: string,
		articleId: string,
		isFastTrack: boolean,
		cartId?: string,
	): Promise<IArticleResponse> {
		let menuArticleUrl = `menus/${menuId}/items/${articleId}?isFastTrack=${isFastTrack ? "true" : "false"}`;

		if (cartId) {
			menuArticleUrl = `${menuArticleUrl}&cartId=${cartId}`;
		}

		return ApiService.fetch(menuArticleUrl, undefined, undefined, "v2", AbortAction.MENU_GET_ARTICLE);
	}

	static async getMenuArticleUpsellGroups(
		menuId: string,
		articleId: string,
		isFastTrack: boolean,
		cartId?: string,
	): Promise<IUpsellGroupListResponse> {
		return ApiService.fetch(
			`menus/${menuId}/items/${articleId}/upsell-groups?isFastTrack=${isFastTrack ? "true" : "false"}` +
				(cartId ? `&cartId=${cartId}` : ""),
			undefined,
			undefined,
			"v2",
			AbortAction.MENU_GET_UPSELL_GROUPS_FOR_ARTICLE,
		);
	}
}

// DTO layer
export class MenuService {
	static async getMenus(placeId: string, deliveryOptionType?: string): Promise<Menu[]> {
		return MenuAPIService.getMenus(placeId, deliveryOptionType).then((data: IMenuListingResponse) =>
			data.menus.map((m) => new Menu(m)),
		);
	}

	static async getMenu(menuId: string, isFastTrack: boolean): Promise<Menu> {
		return MenuAPIService.getMenu(menuId, isFastTrack).then((data: IMenuResponse) => new Menu(data));
	}

	static async getMenuArticle(
		menuId: string,
		articleId: string,
		isFastTrack: boolean,
		cartId?: string,
	): Promise<Article> {
		return MenuAPIService.getMenuArticle(menuId, articleId, isFastTrack, cartId).then(
			(data: IArticleResponse) => new Article(data),
		);
	}

	static async getMenuArticleUpsellGroups(
		menuId: string,
		articleId: string,
		isFastTrack: boolean,
		cartId?: string,
	): Promise<UpsellGroupList> {
		return MenuAPIService.getMenuArticleUpsellGroups(menuId, articleId, isFastTrack, cartId).then(
			(data: IUpsellGroupListResponse) => new UpsellGroupList(data),
		);
	}
}
